import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProcurementListPage from './ProcurementListPage';

export default function ProcurementRoutes() {
  return (
    <Routes>
      <Route index element={<ProcurementListPage />} />
    </Routes>
  );
}
